import { LoaderGetterContext, LoaderSetterContext } from "@state/context";
import { useContext } from "react";

export function useLoading() {
	const loaderSetterCtx = useContext(LoaderSetterContext);
	const loaderGetterCtx = useContext(LoaderGetterContext);

	return {
		setIsLoading: (condition: boolean) => {
			loaderSetterCtx.setIsLoading(condition);
		},
		isLoading: loaderGetterCtx.isLoading,
	};
}
